import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { useVariantIds } from '~/lib/hooks/useVariantIds';

// Components
import CTAButton from '~/components/shared/CTAButton';
import { FOOTER_LINKS } from './data';

const footerListClasses = classNames(
  'list-none mx-auto flex flex-col gap-y-[38px]',
  'md:px-8 md:m-0 md:flex-wrap md:h-[138px] md:gap-x-[148px] md:content-start',
  'lg:pl-[64px]'
);

const Footer: FunctionComponent = () => {
  const { isDarkMode } = useVariantIds();

  const footerClasses = classNames(
    'footer__wrap grid',
    isDarkMode ? 'bg-dark-mode-background' : ''
  );

  const footerLinkClasses = classNames(
    'text-xs leading-[14px] text-center',
    'md:text-left',
    isDarkMode
      ? '[&_a]:text-white [&_button]:text-white'
      : '[&_a]:text-secondary-dark [&_button]:text-secondary-dark'
  );

  const dividerClasses = classNames(
    'm-0 border-none h-px',
    isDarkMode ? 'bg-white/20' : 'bg-[#F4F4F4]'
  );

  const copyrightClasses = classNames(
    'block text-center text-[11px] mt-8',
    isDarkMode ? 'text-white' : 'text-dark-grey-3'
  );

  return (
    <div className={footerClasses}>
      <ul className={footerListClasses}>
        {FOOTER_LINKS.map(({ href, name }) => (
          <li key={`${href}-${name}`} className={footerLinkClasses}>
            <CTAButton
              variant='text-link'
              size='thin'
              href={href}
              elementPosition='FOOTER'
              className={isDarkMode ? '!text-white' : '!text-secondary-dark'}
            >
              {name}
            </CTAButton>
          </li>
        ))}
      </ul>
      <div className='mt-8'>
        <hr className={dividerClasses} />
        <span className={copyrightClasses}>
          © {new Date().getFullYear()} Walmart. All Rights Reserved
        </span>
      </div>
    </div>
  );
};

export default Footer;
